import * as yup from "yup";

export const unitValidationSchema = yup.object().shape({
  title: yup.string().required("Unit name is required"),
  unitId: yup.string().optional(),

  description: yup.string().optional(),

  monthly_rent_amount: yup
    .number()
    .min(0)
    .nullable()
    .test("rent-check", "Monthly rent amount is required", function (value) {
      const { home_rent_amount, site_rent_amount } = this.parent;

      return (
        value != null || home_rent_amount != null || site_rent_amount != null
      );
    }),

  home_rent_amount: yup
    .number()
    .min(0, "Home rent must be greater than or equal to 0")
    .nullable()
    .test("home-rent-check", "Home rent amount is required", function (value) {
      const { monthly_rent_amount } = this.parent;
      return value != null || monthly_rent_amount != null;
    }),

  site_rent_amount: yup
    .number()
    .min(0, "Site rent must be greater than or equal to 0")
    .nullable()
    .test("site-rent-check", "Site rent amount is required", function (value) {
      const { monthly_rent_amount } = this.parent;
      return value != null || monthly_rent_amount != null;
    }),

  available_at: yup.string().optional(),
  occupied: yup.boolean().optional(),

  sqft: yup
    .number()
    .min(0, "Size, sq.ft must be greater than or equal to 0")
    .optional(),
  beds: yup
    .number()
    .integer("Number of beds must be a whole number")
    .min(0, "Number of beds must be greater than or equal to 0")
    .optional(),
  baths: yup
    .number()
    .min(0, "Number of baths must be greater than or equal to 0")
    .optional(),

  amenities: yup.array().of(yup.string()).default([])
});
